module.exports = __webpack_public_path__ + "static/media/affiliate-tutorial-step-4.ef0295c5.webp";